import { graphql, useFragment } from "react-relay";
import type { memberBadgeFragment$key } from "./__generated__/memberBadgeFragment.graphql";

type MemberBadgeProps = {
	badge: memberBadgeFragment$key;
};

export function MemberBadge({ badge }: MemberBadgeProps) {
	const data = useFragment<memberBadgeFragment$key>(
		graphql`
    fragment memberBadgeFragment on Badge {
        text
        textColor
        bgColor
    }
  `,
		badge,
	);

	return (
		<span
			className="text-[10px] text-left font-medium rounded-sm px-2 py-0.5"
			style={{ backgroundColor: data.bgColor, color: data.textColor }}
		>
			{data.text}
		</span>
	);
}
